import { render, staticRenderFns } from "./ConfirmPopover.vue?vue&type=template&id=2456a0d7&scoped=true&"
import script from "./ConfirmPopover.vue?vue&type=script&lang=js&"
export * from "./ConfirmPopover.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmPopover.vue?vue&type=style&index=0&id=2456a0d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2456a0d7",
  null
  
)

export default component.exports